<template>
  <div class="app-container">

    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('addStaff.title') }}</span>
      </div>
      <div class="">
        <el-form ref="form" :model="addStaffInfo" :rules="rules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('addStaff.form.username')" prop="username">
                <el-input 
                  v-model="addStaffInfo.username" 
                  :placeholder="$t('addStaff.form.username')"
                  :maxlength="10" 
                  :minlength="2"
                  show-word-limit />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.position')" prop="relCd">
                <el-select v-model="addStaffInfo.relCd" :placeholder="$t('addStaff.form.position')"
                  style="width:100%">
                  <el-option v-for="(item, index) in addStaffInfo.relCds" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.phone')" prop="tel">
                <el-input v-model="addStaffInfo.tel" :placeholder="$t('addStaff.form.phone')" maxlength="11" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.photo')">
                <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('addStaff.form.sex')" prop="sex">
                <el-select v-model="addStaffInfo.sex" :placeholder="$t('addStaff.form.sex')"
                  style="width:100%">
                  <el-option :label="$t('addStaff.form.male')" value="0" />
                  <el-option :label="$t('addStaff.form.female')" value="1" />
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.email')">
                <el-input v-model="addStaffInfo.email" :placeholder="$t('addStaff.form.email')" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.address')" prop="address">
                <el-input v-model="addStaffInfo.address" :placeholder="$t('addStaff.form.address')" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.relatedOrg')" prop="orgId">
                <el-input v-model="addStaffInfo.orgName" readonly @focus="handleChooseOrg"
                  :placeholder="$t('addStaff.form.relatedOrg')" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="">
          <el-button type="primary" class="float-right" @click="saveStaffInfo">
            <i class="el-icon-check"></i>&nbsp;{{ $t('common.save') }}
          </el-button>
          <el-button class="float-right" style="margin-right:20px;" @click="goBack">
            {{ $t('common.cancel') }}
          </el-button>
        </div>
      </div>
    </el-card>


    <choose-org-tree ref="chooseOrg" @switchOrg="handleSwitchOrg" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { addStaff } from '@/api/frame/staffApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import ChooseOrgTree from '@/components/frame/chooseOrgTree/chooseOrgTree'

export default {
  name: 'AddStaff',
  components: {
    UploadImageUrl,
    ChooseOrgTree
  },
  data() {
    return {
      addStaffInfo: {
        orgId: '',
        orgName: '',
        username: '',
        sex: '',
        email: '',
        tel: '',
        address: '',
        relCd: '',
        relCds: [],
        faceUrl: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        relCd: [
          { required: true, message: '请选择岗位', trigger: 'change' }
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入家庭住址', trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: '请选择关联组织', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('u_org_staff_rel', 'rel_cd')
        this.addStaffInfo.relCds = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleUploadImage(data) {
      console.log(data)
      if (data.length > 0) {
        this.addStaffInfo.faceUrl = data[0]
      }
    },
    handleSwitchOrg(org) {
      console.log(org)
      this.addStaffInfo.orgId = org.orgId
      this.addStaffInfo.orgName = org.allOrgName
    },
    handleChooseOrg() {
      this.$refs.chooseOrg.open()
    },
    addStaffValidate() {
      return this.$refs.form.validate()
    },
    async saveStaffInfo() {
      try {
        await this.addStaffValidate()
        this.addStaffInfo.name = this.addStaffInfo.username
       const {code,msg} =await addStaff(this.addStaffInfo)
       if(code == 0){
        this.$message.success(msg)
        this.goBack()
       } else {
        this.$message.error(msg)
       }
      } catch (error) {
        console.error('保存失败:', error)
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}

.ibox-content {
  padding: 20px;
}
</style>